// extracted by mini-css-extract-plugin
module.exports = {"customButton":"CustomButton_customButton__mySIY","icon":"CustomButton_icon__V1l_O"};